<script setup lang="ts">
import { ErrorMessage, useField } from 'vee-validate'
import { computed } from 'vue'
import ErrorIcon from '/svg/error-icon.svg'

const { name } = defineProps({
  name: {
    type: String,
    required: true,
  },
})

const { errorMessage } = useField(name)
const hasError = computed(() => !!errorMessage.value)
</script>

<template>
    <div class="flex items-center gap-1 text-[10px] font-bold text-[#ed145b] mt-1">
        <img v-if="hasError" :src="ErrorIcon" width="14" alt="error-icon" />
        <ErrorMessage :name="name" />
    </div>
</template>